var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Credit-Card",
    transform: "translate(128.000000, 532.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-76.1-481.5h-39.8c-2.4,0-4.3-1.9-4.3-4.3v-28.5c0-2.4,1.9-4.3,4.3-4.3h39.8     c2.4,0,4.3,1.9,4.3,4.3v28.5C-71.8-483.4-73.7-481.5-76.1-481.5L-76.1-481.5z M-115.9-515.7c-0.8,0-1.4,0.6-1.4,1.4v28.5     c0,0.8,0.6,1.4,1.4,1.4h39.8c0.8,0,1.4-0.6,1.4-1.4v-28.5c0-0.8-0.6-1.4-1.4-1.4H-115.9L-115.9-515.7z",
    id: "Fill-7_1_"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-8_1_",
    points: "-118.8,-512.8 -73.2,-512.8 -73.2,-504.3 -118.8,-504.3    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-9_1_",
    points: "-114.5,-498.6 -113.1,-498.6 -113.1,-495.7 -114.5,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-10_1_",
    points: "-111.7,-498.6 -110.2,-498.6 -110.2,-495.7 -111.7,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-11_1_",
    points: "-108.8,-498.6 -107.4,-498.6 -107.4,-495.7 -108.8,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-12_1_",
    points: "-104.5,-498.6 -103.1,-498.6 -103.1,-495.7 -104.5,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-13_1_",
    points: "-101.7,-498.6 -100.3,-498.6 -100.3,-495.7 -101.7,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-14_1_",
    points: "-98.8,-498.6 -97.4,-498.6 -97.4,-495.7 -98.8,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-15_1_",
    points: "-94.6,-498.6 -93.2,-498.6 -93.2,-495.7 -94.6,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-16_1_",
    points: "-91.7,-498.6 -90.3,-498.6 -90.3,-495.7 -91.7,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-17_1_",
    points: "-88.9,-498.6 -87.5,-498.6 -87.5,-495.7 -88.9,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-18_1_",
    points: "-84.6,-498.6 -83.2,-498.6 -83.2,-495.7 -84.6,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-19_1_",
    points: "-81.8,-498.6 -80.3,-498.6 -80.3,-495.7 -81.8,-495.7    "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "Fill-20_1_",
    points: "-78.9,-498.6 -77.5,-498.6 -77.5,-495.7 -78.9,-495.7    "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcLight);
export default __webpack_public_path__ + "static/media/cc_light.a3a614d986166d412d5dbefb8aeff269.svg";
export { ForwardRef as ReactComponent };